import { useEffect, useReducer } from 'react';
import { getSanityAssetFullUrl } from '@fff-web/constants';
import { getMyBoxDetails, getMyBoxRate } from '../services/myBoxStatus';
import { actions, initialState, myBoxStatusReducer } from '../Store';

const { setMyBox, setMyBoxSuccess, setMyBoxFail } = actions;

const useMyBoxStatus = () => {
  const [{ myBox }, stateDispatch] = useReducer(myBoxStatusReducer, initialState());

  const env = window.location.host === 'fabfitfun.com' ? 'prod' : 'dev';

  useEffect(() => {
    stateDispatch(setMyBox());
    getMyBoxDetails()
      .then((data) => {
        let parsedBoxData = data;

        // Parse sanity images to come from custom CDN.
        if (parsedBoxData && parsedBoxData.imageURL) {
          parsedBoxData.imageURL = getSanityAssetFullUrl(parsedBoxData.imageURL, env);
        }

        getMyBoxRate()
          .then((rateData) => {
            stateDispatch(
              setMyBoxSuccess({
                ...parsedBoxData,
                surveyFinished: rateData.surveyFinished,
                surveyStarted: rateData.surveyStarted,
                eligible: rateData.eligible,
              }),
            );
          })
          .catch(() =>
            stateDispatch(
              setMyBoxSuccess({
                ...data,
                surveyStarted: false,
                surveyFinished: true,
                eligible: false,
              }),
            ),
          );
      })
      .catch((error) => stateDispatch(setMyBoxFail(error)));
  }, []);

  return myBox;
};

export default useMyBoxStatus;
